import { render, staticRenderFns } from "./TheTermsOfServiceLayout.vue?vue&type=template&id=8fa161c4&scoped=true&functional=true"
import script from "./TheTermsOfServiceLayout.vue?vue&type=script&lang=js"
export * from "./TheTermsOfServiceLayout.vue?vue&type=script&lang=js"
import style0 from "./TheTermsOfServiceLayout.vue?vue&type=style&index=0&id=8fa161c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "8fa161c4",
  null
  
)

export default component.exports